import React, { useEffect, useState } from "react";
import { Col, Row, Rate, Typography, Tooltip } from "antd";
import "./talentCards.css";
import { BsFillEyeFill } from "react-icons/bs";
import ps_suitcase from "../../../../../assets/img/ps_suitcase.svg";
import { getImage } from "../../../../../utilities/storageOperations/downloadURL";
import history from "../../../../../routes/history";
import moment from "moment";
import { Link } from "react-router-dom";
import Frame from "../../../../../assets/img/Top_rated@2x.svg";
import { ClearSearchSuggestions } from "../../../../../redux/actions";
import { DefaultRating } from "../../../../../assets/helpers";
import PrivateTagSkillListing from "../../../../../components/PrivateMarketComponents/PrivateTagSkillListing";
import email from "../../../../../assets/icons/email.svg";
import phone from "../../../../../assets/icons/phone.svg";
import { formatPhoneNumber } from "../../../../../shared/helpers";
import { useMediaQuery } from 'react-responsive';
const TalentCards = ({ isPrivate = false, ...props }) => {
  const { Text } = Typography;

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [profilePic, setFavouriesDp] = useState("");
  const [candidateName, setCandidateName] = useState(null);
  const [candidateTitle, setCandidateTitle] = useState(null);
  const [imageError, setImageError] = useState(false);
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const isMobile = useMediaQuery({ maxWidth: 767 });
  // useEffect(async () => {
  //   let profilePic = '';
  //   if (props.users?.profile?.PictureUrl) {

  //     profilePic = await getImage(props?.users?.profile?.PictureUrl)

  //     setFavouriesDp(profilePic)
  //   }
  // }, [props]);
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(async () => {
    if (props?.PictureUrl) {
      // profilePic = await getImage(props?.PictureUrl)
      // console.log('PofilePic URL', profilePic)
      setFavouriesDp(props?.PictureUrl);
    }
  }, [props]);

  const detailsPage = () => {
    const encodeURl = encodeURIComponent(props.data?.SkillListingId);
    history.push({
      pathname: `/profiledetail/${
        props.data?.SkillListingId
          ? props.data?.SkillListingId
          : props.data?.skill_listings?.SkillListingId
      }`,
      state: {
        id: props.data?.SkillListingId
          ? props.data?.SkillListingId
          : props.data?.skill_listings?.SkillListingId,
        Rating: props?.data?.Rating,
        token: "valid",
      },
    });
  };

  // 👇️ if you only need to capitalize first letter
  const capitalizeFirst = (str) => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  };

  useEffect(() => {
    setCandidateName(capitalizeFirst(props.UserNamee));
    setCandidateTitle(
      capitalizeFirst(props?.data?.users?.Profiles?.FirstName?.split("")[0])
    );
  }, [props.UserName]);

  return (
    <>
      <Link
        to={`/profiledetail/${
          props.data?.SkillListingId
            ? props.data?.SkillListingId
            : props.data?.skill_listings?.SkillListingId
        }`}
      >
        <div
          className="card-parent-div"
          onClick={detailsPage}
          key={props.skill_listings?._id}
        >
          <Row className="image-div">
            {
            (userProfile?.EmployeeAssociation?.includes(
              props?.data?.users?.AccountId 
            )|| isPrivate) ? (
              <PrivateTagSkillListing />  
            ) : null}
            <div className="image-circle">
              {/* <div className={props.token != null ? "top-rated-vector" : 'guestUser-vector-icon'}>
                <img src={Frame} />
              </div> */}
              {
                profilePic &&
                !imageError &&
                profilePic?.split("/")?.pop() !== "no-pic.png" ? (
                  <img
                    className="dp"
                    alt=""
                    // src={profilePic}
                    src={`${process.env.REACT_APP_S3_URL}${
                      profilePic?.charAt(0) !== "/" ? "/" : ""
                    }${profilePic}`}
                    onError={() => {
                      setImageError(true);
                    }}
                  />
                ) : (
                  <div className="dp-text">
                    {props?.users?.Profiles?.FirstName ? candidateTitle : "C"}
                  </div>
                )
                // : null
              }
            </div>
            {props.prevviewed ? (
              <BsFillEyeFill
                style={{
                  marginLeft: "80%",
                  color: "#7e7e7e",
                  position: "absolute",
                }}
              />
            ) : null}
          </Row>

          <div className="card-details-column">
            <div className="nameofcandidate">
              {props?.data?.users?.Profiles?.FirstName
                ? `${props.data.users.Profiles.FirstName} ${props.data.users.Profiles.LastName}`
                : props.data?.users?.UserName ?? "Candidate name"}
            </div>
            <div className="rating-value-alignment">
              {/* <Rate className='card-ratings' value={props.Rating === 0 || props.Rating === null ? 3.5 : props.Rating} allowHalf disabled defaultValue={3.5} /> */}
              <Rate
                allowHalf
                className="card-ratings"
                disabled
                defaultValue={
                  props.Rating == null ||
                  props.Rating == "" ||
                  props.Rating == undefined
                    ? DefaultRating
                    : parseFloat(props.Rating)
                }
                style={{
                  color: "#ffba08",
                }}
                //
              />
              <Text className="card-ratings-value">
                <span
                  style={{
                    color: "#ffba08",
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {props.Rating === 0 || props.Rating === null
                    ? DefaultRating
                    : props.Rating}
                </span>{" "}
                {props?.Reviews ? `(${props?.Reviews})` : null}
              </Text>
            </div>
            <Tooltip
      title={
        <span
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {props.title ? (props.title.length > 69 ? props.title.slice(0, 100) + '...' : props.title) : ''}
        </span>
      }
      trigger={isMobile ? 'click' : 'hover'} 
    >
      <div
        className="card-title"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {props.title}
      </div>
    </Tooltip>
            {
              <div className="card-desired-rate">
                <Text className="card-desiredrate-text">
                  {props.professionCode !== "IT"
                    ? "Desired rate"
                    : "Est. Amount"}
                    
                </Text>

                {props.professionCode !== "IT"
                  ? props?.isInvitedTalent ? props?.ClientRate || "$Negotiable" :
                  props?.skill_listings?.MinimumBid === null ||
                    props?.MinimumBid === null
                    ? "$Negotiable"
                    : props?.skill_listings?.MinimumBid
                    ? typeof props?.skill_listings?.MinimumBid === "object"
                      ? "$" +
                        Math.floor(
                          props?.skill_listings?.MinimumBid?.$numberDecimal
                        )
                      : "$" + props?.skill_listings?.MinimumBid
                    : "$" + props.MinimumBid
                    ? typeof props?.MinimumBid === "object"
                      ? "$" + Math.floor(props?.MinimumBid?.$numberDecimal)
                      : "$" + props?.MinimumBid
                    : "$Negotiable"
                  : props?.data?.skill_listings?.ClientRate != null ||
                    props?.ClientRate != null ||
                    props?.ClientRate != undefined
                  ? props?.ClientRate
                    ? "$" + parseFloat(props?.ClientRate)?.toFixed(2)
                    : "$" + props?.ClientRate?.toFixed(2)
                  : "$Negotiable"}
                {props.professionCode !== "IT"
                  ? props?.skill_listings?.MinimumBid === null ||
                    props?.MinimumBid === null
                    ? ""
                    : props?.BudgetTypes
                    ? "/" + props?.BudgetTypes?.BudgetTypeName
                    : props?.skill_listings?.BudgetTypes
                    ? "/" + props?.skill_listings?.BudgetTypes?.BudgetTypeName
                    : props?.skill_listings?.MinimumBidType
                    ? "/" + props?.skill_listings?.MinimumBidType
                    : props?.MinimumBidType && "/" + props?.MinimumBidType
                  : props?.skill_listings?.ClientRate === null ||
                    props?.ClientRate === null
                  ? ""
                  : props?.BudgetTypes
                  ? "/" + props?.BudgetTypes?.BudgetTypeName
                  : props?.skill_listings?.BudgetTypes
                  ? "/" + props?.skill_listings?.BudgetTypes?.BudgetTypeName
                  : props?.skill_listings?.MinimumBidType
                  ? "/" + props?.skill_listings?.MinimumBidType
                  : props?.MinimumBidType && "/" + props?.MinimumBidType}

                {/* {props?.skill_listings?.MinimumBid == null
                  ? "$Negotiable"
                  : props?.skill_listings?.MinimumBid
                  ? typeof props?.skill_listings?.MinimumBid === "object"
                    ? "$" +
                      Math.floor(
                        props?.skill_listings?.MinimumBid?.$numberDecimal
                      )
                    : "$" + props?.skill_listings?.MinimumBid
                  : "$" + props.MinimumBid
                  ? typeof props?.MinimumBid === "object"
                    ? "$" + Math.floor(props?.MinimumBid?.$numberDecimal)
                    : "$" + props?.MinimumBid
                  : "$Negotiable"} */}
                {/* { props?.skill_listings?.MinimumBid == null ? ' ' : props?.BudgetTypes
                  ? "/" + props?.BudgetTypes?.BudgetTypeName
                  : props?.skill_listings?.BudgetTypes
                  ? "/" + props?.skill_listings?.BudgetTypes?.BudgetTypeName
                  : props?.skill_listings?.MinimumBidType
                  ? "/" + props?.skill_listings?.MinimumBidType
                  : props?.MinimumBidType && "/" + props?.MinimumBidType} */}
              </div>
              
            }
            <Row
              style={{
                height: "2.6rem",
                width: windowDimensions.width < 540 && "9rem",
                marginLeft: "auto",
                marginRight: "auto",
                textAlign: "center",
                marginTop: "2px",
              }}
            >
              <Col
                lg={20}
                xs={24}
                style={{
                  color: "#3e3e3e",
                  fontSize: "12px",
                  fontWeight: "500",
                  margin: "auto",
                  borderColor: "#118936",
                }}
              >
                <img src={ps_suitcase} alt="" />
                {
                  <Text style={{ marginLeft: "8px" }}>
                    {props?.users?.Profiles?.ExperienceLevels
                      ?.ExperienceLevelName
                      ? " " +
                        props?.users?.Profiles?.ExperienceLevels
                          ?.ExperienceLevelName +
                        " of experience"
                      : " N/A"}
                  </Text>
                }
              </Col>
            </Row>
            {
  (userProfile?.EmployeeAssociation?.includes(
    props?.data?.users?.AccountId 
  ) || isPrivate) ? (
    <>
      {props?.users?.EmailAddress ? <div style={{ display: "flex", gap: "8px", justifyContent: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        <span><img src={email} alt="" style={{ maxWidth: "100%", height: "auto" }} /></span>
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", color: " #4054B2" }}>
          {props?.users?.EmailAddress ? props?.users?.EmailAddress : "N/A"}
        </span>
      </div>:null}
     {props?.users?.MobilePhone ? <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
        <span><img src={phone} alt="" /></span>
        <span style={{ color: "#3E3E3E" }}>
          {props?.users?.MobilePhone ? formatPhoneNumber(props?.users?.MobilePhone) : "N/A"}
        </span>
      </div>:null}
    </>
  ) : null
}


            {/* /////////////////////////////
            <div style={{ display: "flex", justifyContent: "center"}}>
                <img src={ps_suitcase} />
              <div
              className="experience-container"
              >
                {props?.users?.Profiles?.ExperienceLevels?.ExperienceLevelName
                  ? " " +
                    props?.users?.Profiles?.ExperienceLevels
                      ?.ExperienceLevelName + ' of experienceree'
                  : " N/A"}
              </div>
            </div>
            ////////////////////////////////////////// */}
            <div className="last-active-texts">
              {/* {props.users?.profile?.LastSuccessfulLoginDate ?
              'Last active ' + moment(props.users.profile.LastSuccessfulLoginDate).fromNow()
              : 'Last active not available'
            } */}

              {props.LastLoginDate
                ? "Last active " + moment(props.LastLoginDate).fromNow()
                : "Last active N/A"}
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default TalentCards;
